/**
 * @description Resolve a keyed mega-menu skeleton without affecting hidden cached menus.
 * @param {{
 *   visible: boolean,
 *   menuKey: string,
 *   activeMenuKey: string,
 *   aggregateLoading?: boolean,
 *   categoryLoading?: boolean,
 *   productsLoading?: boolean
 * }} options - Menu loading state.
 * @returns {boolean} Whether the keyed menu should render its skeleton.
 */
export function resolveMegaMenuLoading({
  visible,
  menuKey,
  activeMenuKey,
  aggregateLoading = false,
  categoryLoading = false,
  productsLoading = false,
} = {}) {
  if (!visible || !menuKey || menuKey !== activeMenuKey) return false
  return Boolean(aggregateLoading || categoryLoading || productsLoading)
}
